import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

import type { ShiftBundlesConfig } from "./types";

const DEFAULT_SHIFT_BUNDLES_CONFIG = { enabled: false } as const;

export function useShiftBundlesConfig(): ShiftBundlesConfig {
  const flagValue = useCbhFlag(CbhFeatureFlag.SHIFT_BUNDLES, {
    defaultValue: DEFAULT_SHIFT_BUNDLES_CONFIG,
  });

  return flagValue;
}
